@if (bookingId) {
  <button  class="btn btn-default" (click)="onTextArrivalInstructions()" >
    {{buttonText}}
  </button>
}

